var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMicrosoftOutlook(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0A2767",
    d: "M24 12.571c.001-.188-.096-.362-.256-.461h-.002l-.01-.005-8.317-4.923c-.036-.024-.073-.046-.111-.066-.322-.166-.703-.166-1.024 0-.038.02-.076.042-.112.066l-8.316 4.923-.01.005c-.254.159-.332.493-.174.747.047.075.111.137.187.182l8.316 4.922c.036.024.073.047.112.067.321.166.702.166 1.023 0 .039-.02.076-.043.112-.067l8.316-4.922c.166-.097.268-.276.266-.468Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#0364B8",
    d: "M6.822 9.284h5.457v5.003H6.822V9.284Zm16.062-5.085V1.91c.013-.572-.44-1.046-1.012-1.06H7.71c-.573.014-1.025.488-1.012 1.06v2.289l8.372 2.232 7.814-2.232Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#0078D4",
    d: "M6.698 4.199h5.581v5.023H6.698V4.199Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#28A8EA",
    d: "M17.86 4.199h-5.581v5.023l5.581 5.023h5.024V9.222L17.86 4.199Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#0078D4",
    d: "M12.279 9.222h5.581v5.023h-5.581V9.222Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#0364B8",
    d: "M12.279 14.245h5.581v5.024h-5.581v-5.024Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#14447D",
    d: "M6.822 14.287h5.457v4.547H6.822v-4.547Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#0078D4",
    d: "M17.86 14.245h5.024v5.024H17.86v-5.024Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 1128.4584,
    x2: 1128.4584,
    y1: 811.0833,
    y2: 1.9982,
    gradientTransform: "matrix(.013107 0 0 -.013107 0 23.201776)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#35b8f1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#28a8ea"
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "m23.744 13.008-.01.006-8.317 4.677c-.036.022-.073.043-.111.062-.141.068-.295.105-.451.112l-.454-.266c-.039-.019-.076-.041-.112-.064l-8.428-4.81h-.004l-.276-.154v9.468c.005.632.52 1.141 1.152 1.137h16.133c.01 0 .018-.005.028-.005.134-.008.265-.036.391-.081.054-.023.107-.051.157-.082.037-.021.101-.067.101-.067.286-.212.456-.546.457-.902v-9.468c0 .181-.098.348-.256.437Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#0A2767",
    d: "M23.553 12.534v.58l-8.695 5.987-9.003-6.372c0-.003-.003-.006-.006-.006l-.826-.496v-.419l.341-.006.72.413.016.006.062.039s8.461 4.828 8.484 4.839l.323.19c.028-.011.056-.022.09-.034.016-.011 8.4-4.727 8.4-4.727l.094.006Z",
    opacity: 0.5
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#1490DF",
    d: "m23.744 13.008-.01.006-8.317 4.677c-.036.023-.073.044-.111.063-.323.158-.701.158-1.024 0-.038-.019-.075-.04-.111-.063l-8.317-4.677-.01-.006c-.16-.087-.261-.254-.263-.437v9.468c.004.632.52 1.141 1.151 1.137h16.117c.632.004 1.147-.505 1.151-1.137v-9.468c0 .181-.098.348-.256.437Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m15.539 17.622-.125.07c-.036.023-.073.044-.112.063-.137.067-.286.107-.438.116l3.164 3.742 5.519 1.33c.152-.114.272-.265.35-.437l-8.358-4.884Z",
    opacity: 0.1
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m16.102 17.305-.688.387c-.036.023-.073.044-.112.063-.137.067-.286.107-.438.116l1.482 4.087 7.203.983c.284-.213.451-.547.451-.902v-.122l-7.898-4.612Z",
    opacity: 0.05
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#28A8EA",
    d: "M6.748 23.176h16.099c.248.001.49-.077.69-.224L14.4 17.6c-.038-.019-.076-.04-.112-.064l-8.428-4.81h-.003l-.276-.155v9.436c0 .645.522 1.168 1.167 1.169Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M13.395 6.338v11.905c-.001.418-.254.793-.642.949-.119.052-.249.078-.379.078H5.581V5.873h1.117v-.558h5.676c.564.002 1.02.459 1.021 1.023Z",
    opacity: 0.1
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M12.837 6.896v11.905c.002.135-.027.269-.084.391-.155.382-.525.633-.937.635H5.581V5.873h6.235c.162-.001.321.039.463.117.342.173.558.523.558.906Z",
    opacity: 0.2
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M12.837 6.896v10.789c-.003.564-.458 1.021-1.021 1.025H5.581V5.873h6.235c.162-.001.321.039.463.117.342.173.558.523.558.906Z",
    opacity: 0.2
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M12.279 6.896v10.789c-.001.565-.457 1.023-1.021 1.025H5.581V5.873h5.677c.564.001 1.021.458 1.021 1.023Z",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 162.7469,
    x2: 774.0864,
    y1: 1383.0741,
    y2: 324.2592,
    gradientTransform: "matrix(.013107 0 0 -.013107 0 23.201776)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1784d9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#107ad5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0a63c9"
    }
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M1.023 5.873h10.233c.565 0 1.023.458 1.023 1.023v10.233c0 .565-.458 1.023-1.023 1.023H1.023C.458 18.152 0 17.694 0 17.129V6.896c0-.565.458-1.023 1.023-1.023Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M3.198 10.164c.252-.537.659-.987 1.168-1.291.565-.323 1.207-.484 1.857-.465.603-.013 1.197.139 1.719.441.49.293.885.721 1.137 1.234.274.565.41 1.186.398 1.814.013.656-.127 1.306-.41 1.897-.258.531-.665.975-1.172 1.277-.542.311-1.158.468-1.783.453-.615.015-1.223-.14-1.756-.446-.495-.293-.895-.722-1.152-1.236-.276-.557-.414-1.171-.403-1.792-.012-.651.124-1.295.397-1.886Zm1.245 3.031c.135.34.363.634.658.849.3.21.66.319 1.027.31.39.015.775-.097 1.096-.32.291-.214.513-.51.638-.849.14-.379.21-.781.204-1.185.005-.408-.06-.814-.192-1.2-.116-.349-.331-.656-.618-.885-.313-.233-.697-.352-1.087-.335-.374-.01-.742.099-1.051.312-.3.216-.532.513-.67.857-.304.787-.306 1.659-.004 2.447l-.001-.001Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#50D9FF",
    d: "M17.86 4.199h5.024v5.023H17.86V4.199Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrosoftOutlook);
export default __webpack_public_path__ + "static/media/microsoft_outlook.d8994e0181207b66d495399c820b7885.svg";
export { ForwardRef as ReactComponent };